export enum LedgerAccountType {
  ASSET = "asset",
  LIABILITY = "liability",
  EQUITY = "equity",
  REVENUE = "revenue",
  EXPENSE = "expense",
  TAX_RECEIVABLE = "tax_receivable",
  TAX_PAYABLE = "tax_payable",
  BANK_ACCOUNT = "bank_account",
  CONTACT = "contact",
}

export interface LedgerAccount {
  id: string
  accountCode: string
  accountName: string
  accountType: LedgerAccountType
  entityId?: string | null
  isSystemAccount: boolean
}
